import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert';
import { useAuth } from '../../contexts/AuthContext';
import { useDeviceVault } from '../../contexts/DeviceVaultContext';

// allowOffline: the route also works without a valid sign-in, for a user who
// unlocked this device's saved assessments with their offline PIN (or whose
// sign-in expired while the data was already unlocked). Only the assessment
// pages set it.
const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = [], allowOffline = false }) => {
  const { isAuthenticated, user } = useAuth();
  const vault = useDeviceVault();
  const location = useLocation();

  let role = user?.role;
  if (!isAuthenticated()) {
    const offlineSession = vault.status === 'unlocked' && vault.offline;
    if (offlineSession) {
      if (!allowOffline) return <Navigate to="/dashboard/assessments" replace />;
      role = vault.profile?.role;
    } else if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return <Navigate to="/offline" replace />;
    } else {
      return <Navigate to="/" state={{ from: location.pathname }} replace />;
    }
  }

  if (requiredRole || allowedRoles.length > 0) {
    const ok = (requiredRole && role === requiredRole) || allowedRoles.includes(role);
    if (!ok) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <Alert variant="destructive" className="max-w-md">
            <AlertTitle>Access Denied</AlertTitle>
            <AlertDescription>
              You do not have the required permissions to access this page.
            </AlertDescription>
          </Alert>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
